import React, { useState } from "react";
import "../../Pages/Pages.css";
import { Container, Row } from "react-bootstrap";
import FsLightbox from "fslightbox-react";
import { richcottons } from "../constants/richCotton";

export default function RichCotton() {
  const [toggler, setToggler] = useState(false);
  return (
    <div>
      <div className="mens_header_bg">
        <h3>Rich Cotton Products</h3>
      </div>
      <div className="mens_content">
        <Container>
          <Row>
            {richcottons.map((item, index) => (
              <div className="col-md-3 col-6">
                <div className="card my-3">
                  <div className="card-body">
                    <a
                      className="gallery_img"
                      onClick={() => setToggler(!toggler)}
                    >
                      <img
                        className="img-fluid"
                        key={index}
                        src={item.image}
                        alt="richcottons"
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </Row>
          <FsLightbox
            toggler={toggler}
            sources={richcottons.map((item) => {
              return item.image;
            })}
          />
        </Container>
      </div>
    </div>
  );
}
